module.exports = __webpack_public_path__ + "img/StartFood.256be2a7.png";